/* table view hooks useTableView
*  视图页 加载表格数据 搜索 重置 删除 等
* */

import {ref, nextTick, computed, shallowRef, shallowReactive,reactive, getCurrentInstance,} from 'vue'
import { until } from '@vueuse/core'
import {Search, Download, Filter} from '@element-plus/icons-vue'
import * as _ from 'lodash-es'
// import { exportExcel } from '@/service/excel-http'
import useSettingsStore from '@/store/modules/settings'
import {getQuery} from "@/utils";

/* {object} queryInfo 筛选参数
*  {object} tableConfig 动态表格参数
* */
const useTableView = (queryInfo, tableConfig={}) => {
    const {proxy} = getCurrentInstance();
    // 把tableConfig转为响应式，以防数据没更新
    // 顶层使用浅响应式，仅 columns 保持深度响应式
    const tableProps = shallowReactive(_.cloneDeep(tableConfig))
    if (Array.isArray(tableProps.columns)) {
        tableProps.tableData=reactive([])
        tableProps.total = reactive(0)
        // tableProps.columns = reactive(tableProps.columns)
    }
    const formRef = shallowRef()
    const SearchIcon = Search
    const DownloadIcon = Download
    const FilterIcon = Filter
    const tableData = ref([])
    // 表格组件的ref
    const tableViewRef = shallowRef()
    // 弹窗的ref
    const dialogRef = shallowRef()

    // 弹窗是否显示
    const visibleDialog = ref(false)
    // tableData,数据总数
    const total = ref(0)
    const settingStore = useSettingsStore()

    // 记录当前行的index 用于切换前后行数据
    let currentIndex = null

    // 通用 API 调用方法
    const callApi = async (apiMethod) => {
        proxy.$modal.loading()
        try {
            const res = await apiMethod()
            return res
        } catch (err) {
            console.error('API 调用失败:', err)
            return null
        }finally{
            proxy.$modal.closeLoading()
        }
    }

    /* 请求表格数据
    * @params apiMethod 请求api
    * @params queryInfo 请求参数 {pageNum,pageSize}
    * @params {object} queryInfo.params 由于后端使用新写法除了'pageNum', 'pageSize', 'keyword'以外的参数都要存在params里传给后端
    * */
    const renderTable =async (apiMethod, pageNum = null) => {
        if (pageNum) queryInfo.value.pageNum = pageNum
        const _queryInfo = getQuery(queryInfo.value)
        const res = await callApi(() => apiMethod(_queryInfo))
        if (!res) return
        // 统一处理不同格式的响应数据
        const data = res.rows || res.data?.records || res.data || res.roles || []
        tableData.value = data
        total.value = +res.total || +res.data?.total || 0

        if(tableProps?.tableData){
            tableProps.tableData=tableData.value
            tableProps.total = total.value
            // triggerRef(tableProps)
        }
        // 处理 reloadFlag
        if (queryInfo.value.reloadFlag) {
            queryInfo.value.reloadFlag = false
        }
    }
    // 搜索功能
    const search = _.debounce(async (apiMethod) => {
        await renderTable(apiMethod, 1)
    }, 250)

    /* 把tableProps里的columns转为treeMap 用于 获取dom.__slots__.options
    * */
    const columnMap= computed (() => {
        if (!tableProps?.columns) return {}
        return tableProps.columns.reduce((acc, item) => {
            if (item.prop) acc[item.prop] = item
            return acc
        }, {})
    })

    /* 把特定数组转为map 方便获取对应值
    * @params {Array} arr 数组
    * @params {string} key 作为map参数名的值
    *  */
    const setArrayMap = (arr = [], key) => {
        if (!arr.length) return {}
        return arr.reduce((acc, item) => {
            acc[item[key]] = item
            return acc
        }, {})
    }
    /* 获取导出文件时的参数名
    * @params/type queryInfo.value里的参数
    * @params/domRef select的ref
    * @params/apiMethod tableData的请求接口
    *  */
    const filterQuery = async (type, domRef, apiMethod) => {
        await nextTick()
        queryInfo.value.fileName[type] = domRef.selectedLabel || ''
        await search(apiMethod)
    }
    /* 打开编辑/只读弹窗
     * @params {string} editFlag read-只读查看 edit-编辑 add-新增
      */
    const showDialog = async (row = null, title = '') => {
        // 用于切换行数据
        currentIndex = null
        visibleDialog.value = true

        await until(() => dialogRef.value).toBeTruthy({ timeout: 3000 })
        const _rowId = row[tableProps.rowKey] || row.id
        if (_rowId != null && _rowId !== '') {
            const _tableData=tableProps?.tableData||tableData.value
            const index =_tableData?.findIndex(item =>
                item[tableProps.rowKey] === _rowId || item.id === _rowId
            )
            dialogRef.value.parentInfo = {...row, id: _rowId,index}
            dialogRef.value.preTitle = title ? title : (row.editFlag === 'read' ? '查看' : '编辑')
            currentIndex = index
        } else {
            if (row?.parentId) {
                dialogRef.value.parentInfo = {...row, id: _rowId}
            }
            dialogRef.value.preTitle = title || '新增'
            dialogRef.value.parentInfo.editFlag = 'add'
        }
        // 1.判断是否存在formRef
        const hasForm='formRef' in dialogRef.value
        if(hasForm){
            await until(() => dialogRef.value?.formRef).toBeTruthy({ timeout: 3000 })
            dialogRef.value.formRef?.init()
            if (typeof dialogRef.value.init === 'function') {
                dialogRef.value?.init()
            }
        }else if (typeof dialogRef.value.init === 'function') {
                dialogRef.value?.init()
        }
    }
    /*切换编辑行
    *  @params {string} type pre-上一行 next-下一行
    *  @params {string} editFlag read-只读
    *  @params {object} data 表格数据,可不传，默认使用tableProps.tableData
    * */
    const changeRow = (type, editFlag = null, data = null) => {
        if (!type) return
        const _tableData = data ? data : (tableProps.tableData || tableData.value)
        const _index = type === 'pre' ? currentIndex - 1 : currentIndex + 1
        const row = _tableData[_index]
        if (row) {
            currentIndex = _index
            dialogRef.value.parentInfo = {...row, id: row[tableProps.rowKey] || row.id, index: _index, editFlag}
            nextTick(() => {
                if (dialogRef.value?.formRef) {
                    dialogRef.value.formRef?.init()
                } else if (dialogRef.value?.init) {
                    dialogRef.value.init()
                }
            }).then()

        } else {
            proxy.$modal.msgError('当前已是最后一行。')
        }
    }
    /* 表格行删除
    *  @params {string} id 行id
    *  @params {function} delApi 删除api
    *  @params {function} refreshApi 刷新表格api
    *  @params {function} 模块内自定义的刷新方法
    * */
    const del = async (id, delApi, refreshMethod, msg = '') => {
        try {
            await delApi(id)
            proxy.$modal.msgSuccess({
                message: msg || '删除成功'
            })
            // 数据库删除后，本地未更新，无数据也会显示1，所以 length=1
            if (queryInfo.value?.pageNum > 1 && tableData.value.length === 1) {
                queryInfo.value.pageNum = queryInfo.value.pageNum - 1
            }
            if (refreshMethod) {
                await refreshMethod()
            }
        } catch (e) {
            return e
        } finally {
        }
    }
    // 导出 按条件导出 根据筛选条件拼接文件名
    const getExportFileName = () => {
        let _fileNames = Object.values(queryInfo.value.fileName).filter(item => item).join('_')
        _fileNames ? _fileNames = '_' + _fileNames : ''
        return _fileNames
    }

    /** 导出按钮操作 */
    function handleExport() {
        proxy.download(tableProps.exportApi, queryInfo.value, `导出_${new Date().getTime()}.xlsx`);
    }

    /* 按条件导出
    * @params {Array} includeFieldNames 导出的字段
    * @params {Function} apiMethod 导出的接口
    * */
    const handleExport2 = async (includeFieldNames) => {
        try {
            // settingStore.toggleLoading('open', '.table-view')
            proxy.$modal.loading();

            /* 公共查询参数键，不需要存在params内:
            * 开启排序后'orderColumns', 'orderTypes'在TableView组件内会自动添加
            * */
            const publicKeys = ['orderColumn', 'orderType', 'orderColumns', 'orderTypes', 'enable', 'keyword']
            // 不需要传给后端的字段
            const excludeKeys = ['pageNum', 'pageSize']
            // 非公共参数，通过params传给后端
            // 遍历查询信息对象，根据键名类型更新搜索查询对象
            const _searchQuery = Object.keys(queryInfo.value).reduce((acc, key) => {
                const _value = queryInfo.value[key] || queryInfo.value[key] === 0 ? queryInfo.value[key] : null
                if (publicKeys.includes(key)) {
                    acc[key] = _value
                } else if (!excludeKeys.includes(key)) {
                    acc.params[key] = _value
                }
                return acc
            }, {params: {}})
            if (tableProps.exportApi) {
                // await exportExcel(tableProps.exportApi,{ ..._searchQuery, includeFieldNames }, tableProps.name)
            } else {
                proxy.$modal.msgError('请配置导出接口！')
            }
        } catch (e) {
            console.error(e)
        } finally {
            // settingStore.toggleLoading('close')
            proxy.$modal.closeLoading();
        }
    }
    return {
        until,
        proxy,
        // 响应式数据
        tableProps,
        tableData,
        total,
        columnMap,
        visibleDialog,
        // 组件引用
        formRef,
        tableViewRef,
        dialogRef,
        // 图标
        SearchIcon,
        DownloadIcon,
        FilterIcon,
        // 方法
        renderTable,
        search,
        showDialog,
        changeRow,
        del,
        filterQuery,
        handleExport,
        getExportFileName,
        setArrayMap,
    }
}
export default useTableView

